var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{class:_vm.defaultMargin},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"text-display-4"},[_vm._v(_vm._s(_vm.title))]),_c('v-card-text',[_c('div',{staticClass:"text-body-2"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }